function makeFullHeight(els) {
    const windowHeight = window.innerHeight;
    els.forEach(el => {
        el.style.height = windowHeight + "px";
    });
}